import { Typography, Row, Col }  from 'antd'
import Breakpoint from '../../enums/breakpoint.enum.js'
import useWidth from '../../hooks/useWidth.hook.js'

const { Text, Paragraph } = Typography

export const CacConfirm = ({ flow }) => {
  const width = useWidth()


  const instructions = [{
    sections: [
      {
      title: 'Schedule Your Scan',
      description: <>An Instalab physician will review and send your scan order to {flow?.facility?.name} shortly. Once it’s processed, we’ll email you to schedule your appointment.</>
    }, 
    ]
  }, {
    sections: [{
      title: 'Get Scan Done',
      description: <>The scan itself takes just a few minutes. Please avoid any activities that may impact your heart rate such as exercise, caffeine and alcohol for 4 hours before the scan. </>
    }]
  }, {
    sections: [{
      title: 'View Your Results Online',
      description: <>Most imaging centers will release results within 48 hours. We'll email you once they're uploaded to your Instalab account.</>
    }]
  }]



  return flow?.user && (
    <div className="confirm-step">

      <div style={{fontWeight:600, marginBottom:10}}>Next steps for Coronary Calcium Scan:</div> 
      {instructions?.length > 0 && (
        <div className="instruction-list">
          {instructions.map(({ sections }, instructionIndex) => (
            <div 
              key={`instruction-${instructionIndex}`} 
              className="instruction-item"
            >
              <Row>
                <Col
                  style={{
                    width: width > Breakpoint.SM ? 80 : '100%',
                    marginBottom: width > Breakpoint.SM ? 0 : 10
                  }}
                >
                  <Text className="instruction-index">
                    Step {instructionIndex+1}
                  </Text>
                </Col>

                <Col
                  style={{
                    width: width > Breakpoint.SM ? 'calc(100% - 80px)' : '100%'
                  }}
                >
                  {sections.map(({ title, description }, sectionIndex) => (
                    <div 
                      key={`section-${instructionIndex}-${sectionIndex}`} 
                      className="section-item"
                    >
                      <Text className="section-title">
                        {title}
                      </Text>
                      <Paragraph className="section-description">
                        {description}
                      </Paragraph>
                    </div>
                  ))}
                  </Col>
              </Row>
            </div>
          ))}
        </div>
      )}

    </div>
  )
}

